module.exports = __webpack_public_path__ + "img/offline.58026a3d.png";